export default "__VITE_ASSET__BQgjSZTE__"